import { FuelRobPerTankBM } from '../types/BusinessModel/FuelRobPerTankBM';
import { FuelRobPerTank } from '../types/ViewModel/FuelRobPerTank';

export class FuelRobPerTankFactory {
    public create(data: FuelRobPerTankBM): FuelRobPerTank {
        return new FuelRobPerTank(
            data.tankId,
            data.previousRobInMt,
            data.robInMt,
            data.robDifferenceInMt,
            data.fuelType,
            data.bunkeringInMt,
            data.litreWeight,
            data.sulphurPercent
        );
    }

    public createList(data: FuelRobPerTankBM[]): FuelRobPerTank[] {
        return data.map((h) => this.create(h));
    }
}
